import _toConsumableArray from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module engine/model/operation/markeroperation
 */
import Operation from './operation.js';
import Range from '../range.js';
var MarkerOperation = /*#__PURE__*/function (_Operation) {
  _inherits(MarkerOperation, _Operation);
  var _super = _createSuper(MarkerOperation);
  /**
   * @param name Marker name.
   * @param oldRange Marker range before the change.
   * @param newRange Marker range after the change.
   * @param markers Marker collection on which change should be executed.
   * @param affectsData Specifies whether the marker operation affects the data produced by the data pipeline
   * (is persisted in the editor's data).
   * @param baseVersion Document {@link module:engine/model/document~Document#version} on which operation
   * can be applied or `null` if the operation operates on detached (non-document) tree.
   */
  function MarkerOperation(name, oldRange, newRange, markers, affectsData, baseVersion) {
    var _this;
    _classCallCheck(this, MarkerOperation);
    _this = _super.call(this, baseVersion);
    _this.name = name;
    _this.oldRange = oldRange ? oldRange.clone() : null;
    _this.newRange = newRange ? newRange.clone() : null;
    _this.affectsData = affectsData;
    _this._markers = markers;
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(MarkerOperation, [{
    key: "type",
    get: function get() {
      return 'marker';
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "affectedSelectable",
    get: function get() {
      var ranges = [];
      if (this.oldRange) {
        ranges.push(this.oldRange.clone());
      }
      if (this.newRange) {
        if (this.oldRange) {
          ranges.push.apply(ranges, _toConsumableArray(this.newRange.getDifference(this.oldRange)));
        } else {
          ranges.push(this.newRange.clone());
        }
      }
      return ranges;
    }
    /**
     * Creates and returns an operation that has the same parameters as this operation.
     */
  }, {
    key: "clone",
    value: function clone() {
      return new MarkerOperation(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
    }
    /**
     * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
     */
  }, {
    key: "getReversed",
    value: function getReversed() {
      return new MarkerOperation(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
    }
    /**
     * @inheritDoc
     * @internal
     */
  }, {
    key: "_execute",
    value: function _execute() {
      if (this.newRange) {
        this._markers._set(this.name, this.newRange, true, this.affectsData);
      } else {
        this._markers._remove(this.name);
      }
    }
    /**
     * @inheritDoc
     * @internal
     */
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = _get(_getPrototypeOf(MarkerOperation.prototype), "toJSON", this).call(this);
      if (this.oldRange) {
        json.oldRange = this.oldRange.toJSON();
      }
      if (this.newRange) {
        json.newRange = this.newRange.toJSON();
      }
      delete json._markers;
      return json;
    }
    /**
     * @inheritDoc
     */
  }], [{
    key: "className",
    get: function get() {
      return 'MarkerOperation';
    }
    /**
     * Creates `MarkerOperation` object from deserialized object, i.e. from parsed JSON string.
     *
     * @param json Deserialized JSON object.
     * @param document Document on which this operation will be applied.
     */
  }, {
    key: "fromJSON",
    value: function fromJSON(json, document) {
      return new MarkerOperation(json.name, json.oldRange ? Range.fromJSON(json.oldRange, document) : null, json.newRange ? Range.fromJSON(json.newRange, document) : null, document.model.markers, json.affectsData, json.baseVersion);
    }
  }]);
  return MarkerOperation;
}(Operation);
export { MarkerOperation as default };